//For showing set/question preview modal in library/recent
export function updatePreviewItem(itemId) {
	return (dispatch) => dispatch({ type: 'UPDATE_PREVIEW_ITEM',itemId})	    
}

